import React from 'react';
import PageHeader from 'components/common/PageHeader';
import Helmet from 'react-helmet';
import { Card } from 'react-bootstrap';
import CreditRequestTable from './components/CreditRequestTable';

export default function CreditRequest() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Credit Request | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
      </Helmet>

      <PageHeader title="Credit Request" className="mb-3"></PageHeader>

      <Card className="mb-3">
        <Card.Body>
            <CreditRequestTable/>
        </Card.Body>
      </Card>
    </>
  );
}
